import React, { useEffect, useState, useContext } from "react";
import DateTimePicker from "react-datetime-picker";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import "react-datepicker/dist/react-datepicker.css";
import ReactDatePicker from "react-datepicker";
import { styled } from "@mui/system";
import { Box } from "@mui/material";
import { LanguageContext } from "App";
import "./style.scss";

const DateContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[3],
  backgroundColor: theme.palette.background.paper,
}));
const CustomDatePicker = styled(ReactDatePicker)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
  fontSize: "1rem",
  width: "100%",
  textAlign: "center",
  "&:focus": {
    borderColor: theme.palette.primary.main,
  },
}));

const SearchDayBar = ({ GetAppDay }) => {
  const [SearchDay, setSearchDay] = useState(new Date());
  const { translations } = useContext(LanguageContext);

  return (
    <MDBox
      mt={2}
      mb={1}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <DateContainer>
        <CustomDatePicker
          selected={SearchDay}
          onChange={(date) => setSearchDay(date)}
          dateFormat="dd/MM/yyyy"
          showPopperArrow={false}
          className="date"
        />
      </DateContainer>
      <MDButton
        onClick={() => GetAppDay(SearchDay)}
        sx={{
          backgroundColor: "#3560AD",
          "&:hover": { backgroundColor: "#4682B4" },
          margin: "10px",
        }}
        color="text"
      >
        {translations.getDay}
      </MDButton>
    </MDBox>
  );
};

export default SearchDayBar;
